const endpoints = {}
const files = require.context('./endpoints', true, /\.js$/)

// TODO: Current caveat is that we can't have multiple endpoints with the same name.
// For e.g.: Users/GetAll and Locations/GetAll since both will be technically be named GetAll
// We need to find a way to identify [controller]/[action] instead
files.keys().forEach(path => {
  const endpoint = files(path)
  Object.keys(endpoint).forEach(x => {
    Object.keys(endpoint[x]).forEach(y => {
      Object.defineProperty(endpoints, y, { value: endpoint[x][y] })
    })
  })
})

export default endpoints



// WEBPACK FOOTER //
// ./src/api/index.js